<div
  [bfx-input]="bfxInput"
  [ngClass]="inputDirective.classes"
  #input
  (wheel)="onMouseWheel($event)"
  [title]="(errorMsg)? errorMsg:''"
>
  <div class="bfx-input-label">
    <ng-container
      [ngTemplateOutlet]="inputStartContainer"
      [ngTemplateOutletContext]="{'$implicit': chkBoxLabel}"
    ></ng-container>
    <div [ngClass]="inputDirective.labelClasses" #chkBoxLabel>
      {{label}}<!-- <span *ngIf="required"></span> -->
    </div>
    <ng-container
      [ngTemplateOutlet]="inputEndContainer"
      [ngTemplateOutletContext]="{'$implicit': chkBoxLabel}"
    ></ng-container>
  </div>

  <div [ngClass]="inputDirective.innerClasses">
    <div
      [bfx-field-number]="bfxFieldNumber"
      [ngClass]="fieldDirective.classes"
      [style.display]="hideField ? 'none' : 'flex'"
    >
      <ng-container *ngTemplateOutlet="fieldStartContainer"></ng-container>
      <ng-container *ngIf="fieldContainer !== null">
        <ng-container
          *ngTemplateOutlet="fieldContainer; context: {
        input: {
          onPointerOver: onPointerOver,
          onPointerOut: onPointerOut,
          onFocus: onFocus,
          onBlur: onBlur,
          onKeyDown: onKeyDown,
          onKeyPress: onKeyPress,
          onKeyUp: onKeyUp,
          onInputChange: onInputChange,
          onPaste: onPaste,
        }
      }"
        ></ng-container>
      </ng-container>
      <input
        [ngClass]="fieldDirective.inputClasses"
        *ngIf="fieldContainer === null"
        class="spinner-input"
        #inputField
        type="text"
        autocomplete="off"
        (pointerover)="onPointerOver($event)"
        (pointerout)="onPointerOut($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        (keydown)="onKeyDown($event)"
        (keypress)="onKeyPress($event)"
        (keyup)="onKeyUp($event)"
        (input)="onInputChange($event)"
        (paste)="onPaste($event)"
        [attr.title]="toolTip"
        [attr.tabindex]="tabindex"
        [attr.disabled]="disabled || locked ? '' : null"
        maxlength="22"
      />
      <span *ngIf="fieldSuffix" class="spinner-suffix" fxFlex="none" fxFlexAlign="center"
        >{{fieldSuffix}}</span
      >
      <spinner-buttons
        #spinnerButtons
        class="spin-buttons-right"
        [disabled]="disabled || locked"
        [upDisabled]="atMax"
        [downDisabled]="atMin"
        (spin)="processButtonSpin($event)"
        (focus)="processButtonFocus()"
        (blur)="processButtonBlur($event)"
        (pointerover)="onPointerOver($event)"
        (pointerout)="onPointerOut($event)"
      >
      </spinner-buttons>
      <ng-container *ngTemplateOutlet="fieldEndContainer"></ng-container>
    </div>
  </div>
</div>
